var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1080 1080",
    width: 1080,
    height: 1080,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(358,167)",
    d: "m0 0h16l39 3 51 4 48 2h61l48-2 51-4 39-3h16l16 2 11 4 8 6 7 10 9 20 16 42 17 48 7 23 3 17 1 12v349l-2 19-4 16-7 16-7 10-7 8-11 7-14 6-12 5-9 7-7 10-5 12-4 18-1 19 2 22 9 42v17l-5 10-7 5-9 1-7-3-5-4-5-10v-18l9-43 1-7v-30l-3-17-4-9-4-3-7 1-3 3-1 3v14l9 27v12l-4 8-6 5-18 5-4 4-1 2-1 19-3 9-6 8-7 4-4 1h-8l-8-3-5-4-5-8-2-9 1-13 6-20 5-18 1-15-2-13-5-16-8-14-7-7-10-5-10-2h-74l-11 2-8 4-7 7-6 13-1 5v11l5 21 2 9v12l-4 8-6 5-2 1h-8l-6-4-4-5-2-6v-11l6-24 1-6v-11l-4-13-7-8-3-1h-7l-5 4-2 5v10l2 10v13l-5 8-4 3-7 1-8-4-4-7-1-3v-9l2-11v-11l-3-5v-2l-10-1-7 6-3 8v15l5 22-1 10-5 7-4 2h-6l-6-4-3-5-1-4 1-13 4-16v-14l-5-12-8-7-5-2h-7l-8 4-7 8-5 11-1 5v12l4 19 6 22 2 11-1 13-5 10-7 6-7 3h-10l-10-5-6-7-3-7-1-5v-9l4-18 7-27 1-6v-19l-4-12-12-23-10-19-7-19-4-19-1-9-1-256-8 1h-9l-8-3-7-8-2-6v-13l4-10 8-11 10-12 8-16 3-16 3-22 4-18 5-17 13-37 13-35 11-27 8-16 8-9 6-4 9-3zm307 645-5 6-4 10-1 5v9l3 6 4 1 5-3 4-5 5-14v-11l-4-4z",
    fill: "#740AB1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(346,172)",
    d: "m0 0 30 2 13 2h13l29 2h16l47 2 7 1 32 1h41l56-2 29-1 26-2 31-4h20l10 2 9 2 3 3 3 10 2 5 1 9 1 63v175l-1 63-3 14-6 16-7 8-5 5-7 6-12 6-7 1-1-1-21 1-39 3-26 3-42 2h-103l-20-2-24-2-13-2-18-1-12-2-25-5-13-4-15-8-3-2v-2h-2l-5-6-4-3-4-12-3-8-1-22v-13l1-5-1-2v-28l-1-3 1-16v-37l-1-37v-51l-1-26 1-44v-21l2-13 5-9 5-5z",
    fill: "#5D0485"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(358,167)",
    d: "m0 0h16l39 3 51 4 48 2h61l48-2 51-4 39-3h16l16 2 11 4 8 6 7 10 9 20 16 42 17 48 7 23 3 17 1 12v349l-2 19-4 16-7 16-7 10-7 8-11 7-14 6-12 5-9 7-7 10-5 12-4 18-1 19 2 22 9 42v17l-5 10-7 5-9 1-4-2 9-1 3-3 3-6 1-4v-15l-4-17-2-18-1-12v-28l1-20 2-10 5-13 8-10 14-9 16-6 4-3h2v-2h2l1-3h2l-2-7-1-3 2-9 1-3v-19l-3-16-3-13-3-18-1-7-1-3-1-8-2-5-3-16-2-17-3-16-3-21-2-11-2-4-1-12 2-17 9-29 1-14 1-69-1-41v-177l-2-18-8-16-6-4-5-1v-2l-16-2h-24l-53 5-32 2-53 2h-51l-50-2-36-2-39-4-13-1h-20l-15 1-10 3-2 5-4 4-4 10h-2l-2 23v218l1 39v22l2 18 4 10 6 9 3 4-1 4 3 3 3 5v2h2l4 9 2 9-1 5-1 11-1 3v16l-2 11-4 27v10l-2 16-3 9v11l-3 9v10l-2 6-2 12-1 2 1 9h3l-1 5-5 2 1 4 3-1 1 4 9-1-4 2-1 3-4 2-4 6h-2v2l-7 1-2-2-5 3-3 1-6 1 1 15h2l1 4h2l4 10 4 13 4 26 3 7 2 1-1-11 1-16 3-10 6-8 4-7 10-7 8-3h3v-2l4-1 9 5 7 9 4 10v8l1 6 1 19 2 10 4 1v-12l-2-12v-16l4-8 7-6 10-2 8 1 3 3 4 12 2 5 1 15 4 8 5 2 1-10-1-8v-12h2l3 16v13l-5 8-4 3-7 1-8-4-4-7-1-3v-9l2-11v-11l-3-5v-2l-10-1-7 6-3 8v15l5 22-1 10-5 7-4 2h-6l-6-4-3-5-1-4 1-13 4-16v-14l-5-12-8-7-5-2h-7l-8 4-7 8-5 11-1 5v12l4 19 6 22 2 11-1 13-5 10-7 6-7 3h-10l-10-5-6-7-3-7-1-5v-9l4-18 7-27 1-6v-19l-4-12-12-23-10-19-7-19-4-19-1-9-1-256-8 1h-9l-8-3-7-8-2-6v-13l4-10 8-11 10-12 8-16 3-16 3-22 4-18 5-17 13-37 13-35 11-27 8-16 8-9 6-4 9-3z",
    fill: "#9D0EC0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(358,167)",
    d: "m0 0h16l39 3 51 4 48 2h61l48-2 51-4 39-3h16l16 2 11 4 8 6 7 10 9 20 16 42 17 48 7 23 3 17 1 12v349l-2 19-4 16-7 16-7 10-7 8-11 7-14 6-12 5-9 7-7 10-5 12-4 18-1 19 2 22 9 42v17l-5 10-7 5-9 1-4-2 9-1 3-3 3-6 1-4v-15l-4-17-2-18-1-12v-28l1-20 2-10 5-13 8-10 14-9 16-6 4-3h2v-2h2l1-3h2l-2-7-1-3 2-9 1-3v-19l-3-16-3-13-3-18-1-7-1-3-1-8-2-5-3-16-2-17-3-16-3-21-2-11-2-4-1-12 2-17 9-29 1-14 1-69-1-41v-177l-2-18-8-16-6-4-5-1v-2l-16-2h-24l-53 5-32 2-53 2h-51l-50-2-36-2-39-4-13-1h-20l-15 1-10 3-1 3-6 5-7 15-2 23v98l-1 91-1 27h-1l-1-30-2-135-2-44-2-17 11-24 9-10 6-4 9-3z",
    fill: "#9E15FE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(542,768)",
    d: "m0 0 19 1 4 1v5h11l13 2 12 2 6 3 10 7 5 5 7 5 8 12 4 9 3 8 2 21 4 8 3 1 6-1v-6l-3-3v-2l-3-1v-15l4-11 4-2-4 11-1 5v9l2 5 4 1 5-3 4-7 4-11v-11l-3-3-4-2 7-1 4 3 2 7 2 3v13l1 6 7 2 4 3-2-11-3-5v-21l3-4h2v-2h2l1-2 3 1h8l2 1v2l4 1 6 11 4 12 3-15h1l-1 29v28l2 22 2 12 3 13v15l-3 8-3 5-2 1h-11l-6-5-5-10v-18l9-43 1-7v-30l-3-17-4-9-4-3-7 1-3 3-1 3v14l9 27v12l-4 8-6 5-18 5-4 4-1 2-1 19-3 9-6 8-7 4-4 1h-8l-8-3-5-4-5-8-2-9 1-13 6-20 5-18 1-15-2-13-5-16-8-14-7-7-10-5-10-2h-74l-11 2-8 4-7 7-6 13-1 5v11l5 21 2 9v12l-4 8-6 5-2 1h-8l-6-4-4-5-2-6v-11l2-6 4-2 3-5 2-1 2-17 2 3v9h2l2 3 1-22 3-14 6-9 8-9 7-5 5-1v-2h2v-2l10-4 8 1 4-1v-2z",
    fill: "#9D0EC0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(783,225)",
    d: "m0 0 2 2 10 27 15 42 6 19 4 18 2 18v349l-1 13-2 2-1-31-3-24-6-25-7-32-7-28-5-25-5-22-4-30v-44l2-14v-11l1-3v-12l1-3h6l1-9-1-1-1-14 4-4 6-1 4 3h2v-10l3-6h2l2-8v-19l-5-20-8-29-8-27-3-9-5-19-2-12z",
    fill: "#8A0FFB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(305,430)",
    d: "m0 0 3 3 1 2v74l-3 17-7 33-7 30-5 24-6 27-5 26-3 16-3 27 1 16 4 20 1 6-3-4-6-20-3-20v-256l2 1h14l9-2v-2l5-3h2l7-14z",
    fill: "#73058B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(358,167)",
    d: "m0 0h16l39 3 51 4 48 2h61l48-2 51-4 39-3h16l16 2 11 4 8 6 7 10 9 20 1 13-1 6-1 35-1 104v103l1 30 3 23 5 26 4 15 6 29 5 23 2 9 1 2 2 14 3 12 1 14 2 6v9l2 15v17l-1 2h-3l-5-14-6-32-4-17-1-2-1-10-2-8-4-17-5-18-6-25-4-15-6-33 1-9 1-2 2-15 1-22v-270l-4-16-5-9-8-7-5-2-19-3h-24l-53 5-32 2-53 2h-51l-50-2-36-2-39-4-13-1h-20l-15 1-10 3-1 3-6 5-7 15-2 23v98l-1 91-1 27h-1l-1-30-2-135-2-44-2-17 11-24 9-10 6-4 9-3z",
    fill: "#DD40F6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(358,169)",
    d: "m0 0h20l43 4 9 1 36 2 50 2h51l53-2 43-3 42-4h24l13 2 3 1v2l7 1 1 2-7-1-10-2h-20l-42 5-17 1-62 2-32 1h-36l-30-1-3-1-54-2h-12l-26-2h-15l-13-2-28-2-14 7-6 10-2 5-1 17v25l-1 42 1 25v54l1 29v39l-1 12 1 2v28l1 7-1 1v21l1 13 6 16 2 5 7 6v2h2v2l5 2 13 7 17 5 22 4 12 2 26 2 16 2 23 2 15 1h105l31-2 23-2 21-2 24-2 22-1v2l12-4 8-5 2 1-8 7-10 6-11 2-25 3-27 2-3 1-57 1-9 1h-55l-30-1-17-1-38-3-36-4-7-2-15-2-14-3-16-6-17-9-5-5-4-2-10-15-4-10-2-18v-26l-1-39v-214l2-20 1-3h2l1-5 3-6 5-6 3-3 8-3z",
    fill: "#8508A0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(305,216)",
    d: "m0 0h2v38l1 22 1 79v53l-1 10h-3l-1 2-4-9-6-8v-2h-2l-5-6-4-3v-2l-5-2-11-9-3-6-2-10 1-16 5-27 6-20 13-37 13-35z",
    fill: "#85059A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(763,521)",
    d: "m0 0 1 4 1 18 4 24 2 9 9 42 4 15 6 36 5 25 4 22 2 6 1 18-3 10-2 3v8l-5 5-6 7-14 7-2 2-12 5-9 7-7 10-5 12-4 18-1 19 2 22 9 42v17l-5 10-7 5-9 1-4-2 9-1 3-3 3-6 1-4v-15l-4-17-2-18-1-12v-28l1-20 2-10 5-13 8-10 14-9 16-6 4-3h2v-2h2l1-3h2l-2-7-1-3 2-9 1-3v-19l-3-16-3-13-3-18-1-7-1-3-1-8-2-5-3-16-2-17-3-16-3-21-2-11-2-4-1-12 2-17z",
    fill: "#8A0EFB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(645,779)",
    d: "m0 0h48l5 1h13l13-1h12l2 5-5 12-1 6-4 9-2 20-3-3-4-13-5-7-1-2h-2v-2h-12-4v2l-4 4v21l4 8 1 9-12-6-2-6v-13l-3-5-2-4-2-3-7 1-5 3-5 4-4 11v15l5 5 1 5-3 3-5 1-5-5-2-5-2-21-4-10-5-10-5-7v-4h2v-12l2-3z",
    fill: "#6A079E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(637,831)",
    d: "m0 0 3 3 4 16 3 10 4 6 5 1v-2h3l2-5 2-4h2v-7l7-4 7-7 2 3 3 16h2l1 2 6 1 3 3v6h2l-2 7-7 4-15 4-4 4-1 2-1 19-3 9-6 8-7 4-4 1h-8l-8-3-5-4-5-8-2-9 1-13 6-20 5-18 1-15 1-7 1 3 2-1z",
    fill: "#FC04AA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(358,167)",
    d: "m0 0h16l39 3 51 4 48 2h61l48-2 51-4 39-3h16l16 2 11 4 8 6 7 10 7 15v11l-2 44v233l2 19v13l-3 2-1 8-3-3v-32l1-22v-270l-4-16-5-9-8-7-5-2-19-3h-24l-53 5-32 2-53 2h-51l-50-2-36-2-39-4-13-1h-20l-15 1-10 3-1 3-6 5-7 15-2 23v98l-1 91-1 27h-1l-1-30-2-135-2-44-2-17 11-24 9-10 6-4 9-3z",
    fill: "#DC3FF5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(309,818)",
    d: "m0 0h2l3 8 2 18 4 9 6 9 3 2h2l1 20v-18l-2-10-4-14-1-9v-15l2 1 3 19 8 30 2 11-1 13-5 10-7 6-7 3h-10l-10-5-6-7-3-7-1-5v-9l4-18 7-27 2-8h2l2-3 2 6 1-1z",
    fill: "#FC03AA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(343,541)",
    d: "m0 0 16 8 18 6 22 4 12 2 26 2 16 2 23 2 15 1h105l31-2 23-2 21-2 24-2 22-1v2l12-4 8-5 2 1-8 7-10 6-11 2-25 3-27 2-3 1-57 1-9 1h-55l-30-1-17-1-38-3-36-4-7-2-15-2-14-3-16-6-17-9z",
    fill: "#6A069D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(720,844)",
    d: "m0 0 2 2 2 12h2l1 25 2 4 2 11 1 8 3 13v15l-3 8-3 5-2 1h-11l-6-5-5-10v-18l9-43 4-8z",
    fill: "#FB03AA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(305,430)",
    d: "m0 0 3 3 1 2v74l-3 17-7 33-7 30-5 24-6 27-5 26-3 16-3 27 1 16 4 20 1 6-3-4-6-20-2-13 1-1 1-20 3-26 10-47 8-36 8-40 4-18 4-21v-14l-3-20-3-8v-2l-11-1-4-2-10-2-6-2v-1l13-1 9-2v-2l5-3h2l7-14z",
    fill: "#85069B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(637,831)",
    d: "m0 0 3 3 4 16 3 10 4 6 5 1v-2h3l2-5 2-4h2v-7l7-4 7-7 2 3 3 16h2l1 2 6 1 3 3v6h2l-1 6-11 1h-2v-2l-6-1-4-1-3 9-4 4-2 4-2 18-3 5-5-5-8-16-2-1-3-9v-12l-2-16-3-4h-2l-2 11-1-4 1-15 1-7 1 3 2-1z",
    fill: "#D502A3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(334,176)",
    d: "m0 0 3 1-5 3-6 10-2 5-1 17v25l-1 42 1 25v54l1 29v39l-1 12 1 2v28l1 7-1 1v21l1 13 6 16 2 5 7 6v2h2l1 4-8-5-10-15-4-10-2-18v-26l-1-39v-214l2-20 1-3h2l1-5 3-6z",
    fill: "#7A0590"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(261,371)",
    d: "m0 0h2l2 8 10 19 4 8v9l-1 3-4 1-3-3h-3l-2 10h-2l-1-2-1-11-2-6-9 5-4 6v8l-1 3h-2l-1 3h-2l1 14-5-1-5-6-2-8v-8l2-9 7-11 9-10 8-13 3-7h2z",
    fill: "#DC3FF5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(745,172)",
    d: "m0 0 6 1 8 6 5 6 4 8 3 14v270l-1 22-2 15-3 7-1-4 1-3 1-14 1-69-1-41v-177l-2-18-8-16-6-4-5-1z",
    fill: "#8C0FFC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(697,802)",
    d: "m0 0 4 1h8l2 1v2l4 1 6 11 4 12 3-15h1l-1 29v28l1 15-3-4v-25h-2l-3-13-2 19-4 5v-34l-3-17-4-9-4-3-7 1-3 3-1 3v14l9 27v12l-4 8-2-2 2-3h-2v-6l-3-1v-2h-6l-1-3h-2l-2-5-2-11-1-2-8 8-3 2h-3l2-4 4-7 4-11v-11l-3-3-4-2 7-1 4 3 2 7 2 3v13l1 6 7 2 4 3-2-11-3-5v-21l3-4h2v-2h2z",
    fill: "#9C0EC0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(408,790)",
    d: "m0 0 8 1 3 3 4 12 2 5 1 15 4 8 5 2 1-10-1-8v-12h2l3 16v13l-5 8-4 3-7 1-8-4-4-7-1-3v-9l2-11v-11l-3-5v-2l-10-1-7 6-3 8v15l5 22-1 10-5 7-4 2h-6l-6-4-2-6 1-4 4-4 2-8 1-13h1l3 23 3 5h3l-2 5-2 2 3-1 2-4 1-11-2-10-2-12v-16l4-8 7-6z",
    fill: "#9E0FC2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(637,789)",
    d: "m0 0 1 2 4 1 1 6h2l6 8 1 2 2 13 9-11 2-1h6v-7l8-1 4 8 1 3v19h2l3 6v2h3l2-3 2 12-12-6-2-6v-13l-3-5-2-4-2-3-7 1-5 3-5 4-4 11v15l5 5 1 5-3 3-5 1-5-5-2-5-2-21-4-10-5-10-5-7v-4h2l1-7z",
    fill: "#74058B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(743,170)",
    d: "m0 0 6 1 8 4 5 4 7 10 7 15v11l-2 44v233l2 19v13l-3 2-1 8-3-3v-32l1-22v-270l-4-16-5-9-8-7-10-4z",
    fill: "#FDFDFD"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(646,790)",
    d: "m0 0h14l3 6 10-4 9 1 3 1 1-3h8l2 8-1 7-4 4v21l2 3v6l-4-1-3-5v-3h-2l-1-19-4-9v-2l-7 2-1 6-8 2-9 11-2-4-1-10-4-6-2-4h-2l-1-6z",
    fill: "#73058B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(304,220)",
    d: "m0 0 1 4-6 25-7 22-6 17-5 18-7 21-5 21-1 19-2 5-2-2-2-7 1-16 5-27 6-20 13-37 13-35z",
    fill: "#72058B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(359,778)",
    d: "m0 0 6 2 6 4 6 8 4 10v8l1 6 1 19 2 10 4 1 1-10h1l1 11-2 10-3 4-3-1 4-5 1-2-3 1-4-6-2-14-3 12-5 5v6l-2-2-1-4 1-13 4-16v-14l-5-12-8-7-5-2h-7l-8 4-7 8-5 11-2 9h-1v18l-2-3v-23l5-10 5-6 2-4 10-7 8-3h3v-2z",
    fill: "#9D0EC1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(734,815)",
    d: "m0 0 2 4-3 15-1 19 2 22 9 42v17l-5 10-7 5-9 1-4-2 9-1 3-3 3-6 1-4v-15l-4-17-2-18-1-12v-28l2-15 4-13z",
    fill: "#DC3FF6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(776,207)",
    d: "m0 0 2 2 1 13-1 6-1 35-1 104v133l-2-1-1-7v-233l2-44z",
    fill: "#DC3FF5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(358,167)",
    d: "m0 0h16l39 3 51 4 48 2h61l48-2 51-4 39-3h16l16 2v2l2 1-16-2h-24l-53 5-32 2-53 2h-51l-50-2-36-2-39-4-13-1h-20l-15 1-12 5-2-1 4-3 9-3z",
    fill: "#E988F9"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(472,825)",
    d: "m0 0 2 3 2 24 5 10 3 1-1 8v3l-2 5-4 2h-8l-7-6-3-8v-11l2-6 4-2 3-5 2-1z",
    fill: "#F904AA"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(264,451)",
    d: "m0 0h1l1 5 1 88 1 61 1 21-1 34-3 44h-1z",
    fill: "#5D0485"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(328,783)",
    d: "m0 0 6 1 2 6-6 7-2 4-2 3-4 12v10l2 13-1 5-5-5-2-8-3-22-5-17 1-5h11z",
    fill: "#6A079E"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(697,802)",
    d: "m0 0 4 1h8l2 1v2l4 1 6 11 4 12 3-15h1l-1 29v28l1 15-3-4v-25h-2l-3-13-2 19-4 5v-34l-3-17-4-9-4-3-7 1-3 3-2 9h-2v-9l3-4h2v-2h2z",
    fill: "#9C0EBF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(494,789)",
    d: "m0 0h2l-1 4-5 6-5 11-1 5v11l5 21 2 9v12l-4 8-6 5-2 1h-8v-1l8-2 3-3 1-2-2-1 3-10-4-1-5-10-1-15h2l2 3 1-22 3-14 6-9z",
    fill: "#9D0EC3"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(783,225)",
    d: "m0 0 2 2 10 27 15 42 6 19 4 18 2 18v348h-1l-1-47v-297l-2-20-4-16-15-46-15-42z",
    fill: "#730AAC"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(745,172)",
    d: "m0 0 6 1 8 6 5 6 4 8 3 14v270l-2 3v-206l-1-62-2-16-7-14-7-6-7-2z",
    fill: "#D339F7"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(309,818)",
    d: "m0 0h2l3 8 2 18 4 9 6 9 3 2h2v21l-5-1-12-14-2-10-1-11-1-22z",
    fill: "#D602A3"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(446,790)",
    d: "m0 0h11l5 1v2l4 2 5 5 2 6 2 17v14h-1l-1-9-2 14-3 1-2 5-4 3-1-4 5-21v-11l-4-13-7-8-3-1h-7l-4 2 2-4z",
    fill: "#9C0EC0"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(325,818)",
    d: "m0 0 2 1 3 19 8 30 2 11-1 13-5 10-7 6-7 3h-10v-1l10-2 6-4 5-9 1-5v-24l-2-10-4-14-1-9z",
    fill: "#DD40F6"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(390,787)",
    d: "m0 0 5 2 1 3-6 9-2 5v16l2 12v10l-1 2-4-1-3-10-1-19-1-7v-11l3-1 4-9z",
    fill: "#740590"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(646,790)",
    d: "m0 0h14l2 5-1 6h2l3 6-1 3-5 5-6 7-2-4-1-10-4-6-2-4h-2l-1-6z",
    fill: "#5D0485"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(388,812)",
    d: "m0 0h1l2 15 4 18-1 10-5 7-4 2h-6l-6-4-2-6 1-4 4-4 2-8 1-13h1l3 23 3 5h3l-2 5-2 2 3-1 2-4 1-11-2-10-2-12v-9z",
    fill: "#D602A3"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(358,169)",
    d: "m0 0h20v2l21 1 27 3 17 1v2l-3 1h-12l-26-2h-15l-13-2-28-2-7 3-7 1 1-3 10-4z",
    fill: "#6D08A3"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(433,786)",
    d: "m0 0 7 1v2l2 1-6 8-2 6v10l1 6v10l-5-2-3-7-2-12v-15l5-7z",
    fill: "#73058B"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(358,167)",
    d: "m0 0h16l39 3 51 4 48 2v1h-46l-36-2-39-4-13-1h-20l-15 1-12 5-2-1 4-3 9-3z",
    fill: "#ED9FFA"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(758,181)",
    d: "m0 0 4 4 5 11 2 16 1 63-1 66h-2l-1-31v-97l-2-18-6-12z",
    fill: "#9311FC"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(674,872)",
    d: "m0 0 6 1 6 2h6l4-1-1 3-9 4-12 3-4 4-1 2-1 19-3 9-6 8-7 4-4-1 8-4 6-8 1-4 1-24 3-5h2l3-9z",
    fill: "#F909B1"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(480,786)",
    d: "m0 0h5l1 4-2 7-2 4-2 1v7l-1 5v27l-4-4-2-24-3-17h4l2-5 1-3z",
    fill: "#85069B"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(766,779)",
    d: "m0 0 4 1v2l-12 5-9 7-7 10-6 14-2-2-5 18h-1v-10l2-10 5-13 8-10 14-9z",
    fill: "#A016FB"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(676,801)",
    d: "m0 0h3l4 8 1 3v19h2l3 6v2h3l2-3 2 12-12-6-2-6v-13l-3-5-2-4-2-3-7 1-5 3-5 4-3 7h-1v-5l9-11 2-1h6v-7z",
    fill: "#86069B"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(631,795)",
    d: "m0 0 4 4v2h2l8 13 2 7 1 14v13l4 6h4l1-4 3 1-1 6-7 2-5-5-2-5-2-21-4-10-5-10-5-7v-4h2z",
    fill: "#85069B"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(679,767)",
    d: "m0 0 6 1 23 4 4 2h-24v-1h-6l-2 1h-22l-9 1-9 3-13 1 2-2 11-2v-2l7-1v-2l5-1h14z",
    fill: "#6A079E"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(309,787)",
    d: "m0 0 5 1 3 10 1 17 1 4 2 1 2 12 1 11h-3l-3-4-2-8-3-22-5-17z",
    fill: "#85069B"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(472,825)",
    d: "m0 0 2 3 2 24 5 10 3 1-1 8-3 4-3-1-6-12-1-20z",
    fill: "#D602A3"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(482,820)",
    d: "m0 0h1l4 20 4 16v12l-4 8-6 5-2 1h-8v-1l8-2 4-4 2-5v-10l-3-20-1-17z",
    fill: "#DD40F6"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(730,843)",
    d: "m0 0 2 4 1 19 3 20 7 31v12h-2l-1-9-3-9-4-17-3-19z",
    fill: "#F8E0FC"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(299,234)",
    d: "m0 0 1 2-10 29-11 31-10 33h-2l1-9 6-20 13-37 10-27z",
    fill: "#5F0486"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(686,791)",
    d: "m0 0h8l2 8-1 7-4 4-1 20-3-4-1-3v-14l-1-17z",
    fill: "#5F0488"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(745,172)",
    d: "m0 0 6 1 8 6 5 6 4 8 3 14v68l-2-1-1-62-2-16-7-14-7-6-7-2z",
    fill: "#DD40F6"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(727,788)",
    d: "m0 0h3l-2 9h-2l2 6v8l-2 2-7-10-4-7-3-3v-2l5-1 6 3 1-3h3z",
    fill: "#73058B"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(714,797)",
    d: "m0 0 4 2 7 12 2 2v9l-1 9-3-3-4-13-5-7h-1l-1-7z",
    fill: "#85069B"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(768,436)",
    d: "m0 0h1l1 44v19l-2 15-3 7-1-4 1-3 1-14 1-63z",
    fill: "#9012FB"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(316,787)",
    d: "m0 0h5l2 5v14l-2 14-3-1-1-10-2-15-1-6z",
    fill: "#73058B"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(720,844)",
    d: "m0 0 2 2 2 12h2l1 33h-3l-2-6v-14l-1-9h-2z",
    fill: "#D602A3"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(327,176)",
    d: "m0 0 2 1-6 7-4 8-4 16-2 21-2-2-2-16v-6l9-19z",
    fill: "#FDFAFD"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(783,225)",
    d: "m0 0 2 2 10 27 15 42 4 12-1 3-3-5-16-47-11-31z",
    fill: "#7109A6"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(670,884)",
    d: "m0 0 2 1-3 5-1 19-3 9-6 8-7 4-4-1 8-4 6-8 1-4 1-24z",
    fill: "#E055F6"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(424,795)",
    d: "m0 0 2 1v13l3 15 1 4 4 1 1-7 2 4-1 10h-4l-5-5-2-5-1-15-3-8 1-7z",
    fill: "#84069D"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(480,786)",
    d: "m0 0h5l1 4-2 7-2 4-2 1v7l-1 5h-2l-3-17 3-9z",
    fill: "#6A079E"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(390,787)",
    d: "m0 0 5 2 1 3-6 9-3 9-1 10-2-4v-22l3-6z",
    fill: "#69069D"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(494,789)",
    d: "m0 0h2l-1 4-5 6-5 11-3 13v11l-2-3-1-4v-9l3-14 6-9z",
    fill: "#9914F9"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(433,792)",
    d: "m0 0 4 2-1 4-2 6v18l-3-3-3-8v-14z",
    fill: "#5D0485"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(388,812)",
    d: "m0 0h1l2 15 4 18-1 10-5 7-4 1 5-8 1-11-2-10-2-12v-9z",
    fill: "#E364F7"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(766,779)",
    d: "m0 0m-3 1h3v2l-13 6-9 7-7 10-5 10-2 8h-1v-7l6-15 8-10 14-9z",
    fill: "#8A0FFC"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(708,791)",
    d: "m0 0 5 2v2l3 1-3 6v4h-2v-2h-12l3-3h2l-1-3h-2v-2h2l2-4z",
    fill: "#750BB2"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(375,848)",
    d: "m0 0h2l5 11 4 3-1 2h-6l-6-4-2-6 1-4z",
    fill: "#F70AB2"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(381,835)",
    d: "m0 0h2l2 10 4 1 1-10h1l1 11-2 10-3 4-3-1 4-5 1-2-3 1-4-6z",
    fill: "#9D0EC3"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(683,827)",
    d: "m0 0 1 4h2l3 6v2h3l2-3 2 12-12-6-2-6v-8z",
    fill: "#85069C"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(482,820)",
    d: "m0 0h1l4 20 4 16-1 7-2-3-3-14-4-17z",
    fill: "#F5CBFB"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(269,712)",
    d: "m0 0h1l2 19 3 14 1 6-3-4-6-20-1-5v-8l2 2z",
    fill: "#7A0699"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(325,818)",
    d: "m0 0 2 1 3 19 3 11v6l-2-1-6-21z",
    fill: "#F9E2FC"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(433,786)",
    d: "m0 0 7 1v2l2 1-4 6-5-3-5 4-1-6 3-4z",
    fill: "#6A079E"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(671,802)",
    d: "m0 0 3 1 4 8-1 3-2-3-7 1-5 3-5 4-3 7h-1v-5l9-11 2-1h6z",
    fill: "#760AAF"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(331,799)",
    d: "m0 0 1 4-3 7-2 9h-1v18l-2-3v-23l5-10z",
    fill: "#9713F5"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(358,169)",
    d: "m0 0h20v1l-29 2-10 4-7 1 1-3 10-4z",
    fill: "#A716C9"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(382,816)",
    d: "m0 0h1l2 18 2 6h2l1-4v8l-1 2-4-1-3-10z",
    fill: "#86069B"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(334,792)",
    d: "m0 0 1 3-8 11-3 10-1 13-2-3v-10l4-13 4-4v-3z",
    fill: "#7C0BB4"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(333,857)",
    d: "m0 0 1 3h2l4 19-1 6-2-2-4-22z",
    fill: "#F7D8FC"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(419,827)",
    d: "m0 0 3 4v2h2l3 7 5 2v1h-8l-3-5-4-8z",
    fill: "#D602A3"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(388,812)",
    d: "m0 0h1l2 15 2 8-1 9h-1l-2-10-2-12v-9z",
    fill: "#D648F3"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(659,817)",
    d: "m0 0 2 1-4 10-1 5v11l-3-1v-13l4-11z",
    fill: "#B222D7"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(435,806)",
    d: "m0 0h2l3 16v8l-2-2-3-10z",
    fill: "#ED9CF9"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(476,793)",
    d: "m0 0 2 3 2 13-1 5h-2l-3-17z",
    fill: "#73058B"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(745,172)",
    d: "m0 0 6 1 8 6 5 6 4 8-1 4-8-15-7-6-7-2z",
    fill: "#D93DF3"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(418,175)",
    d: "m0 0 25 1v2l-3 1h-12l-8-1v-2z",
    fill: "#7008A4"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(812,310)",
    d: "m0 0 3 1 4 16 2 14-2 1-4-20-3-9z",
    fill: "#7E0DB6"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(231,417)",
    d: "m0 0 1 2-1 4v8l3 9 4 6h-3l-4-5-2-6v-13z",
    fill: "#E709B1"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(697,802)",
    d: "m0 0 2 1v3l-5 4-2 9h-2v-9l3-4h2v-2h2z",
    fill: "#8D12C3"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(327,524)",
    d: "m0 0 13 13v2h2l1 4-8-5-8-12z",
    fill: "#7E0594"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(331,175)",
    d: "m0 0 2 1-7 6-8 16-1-3 4-9 4-6z",
    fill: "#DD40F6"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(697,846)",
    d: "m0 0 3 1 2 7v12l-2-3-3-14z",
    fill: "#E055F6"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(395,794)",
    d: "m0 0 1 3-4 5-3 10-2 1v-7l4-8z",
    fill: "#8A10BC"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(690,819)",
    d: "m0 0h2l2 11 2 7-3-1-3-5z",
    fill: "#BD48DE"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(386,801)",
    d: "m0 0h2l-1 9-1 10-2-4v-11z",
    fill: "#5D0485"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(334,176)",
    d: "m0 0 3 1-5 3-6 10-3 3 1-5 3-6zm-13 17 2 1-2 2z",
    fill: "#76058C"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(424,795)",
    d: "m0 0 2 1v7l-1 5-3-2-1-7 1-3z",
    fill: "#85069B"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(437,800)",
    d: "m0 0 1 2-1 4h-2l1 16-2-2-1-6v-10h2z",
    fill: "#9313C4"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(818,719)",
    d: "m0 0h1l-1 9-4 11-1-4 4-15z",
    fill: "#9312EF"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(479,802)",
    d: "m0 0 3 2-1 7-2 16h-1v-15l1-5z",
    fill: "#7D0BB5"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(380,798)",
    d: "m0 0h3v15l-2 3-1-7z",
    fill: "#85069C"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(727,788)",
    d: "m0 0h3l-2 9-4-1-1-3 1-3h3z",
    fill: "#5D0485"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(636,843)",
    d: "m0 0h2l1 4-4 2-2 11-1-4 2-11z",
    fill: "#BC0EB9"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(326,812)",
    d: "m0 0 2 1-1 6h-1v18l-2-3v-18z",
    fill: "#DD40F6"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(494,789)",
    d: "m0 0h2l-1 4-6 5-4 3 2-5z",
    fill: "#8E0FF4"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(482,811)",
    d: "m0 0 2 4-2 8v11l-2-3v-9l1-9z",
    fill: "#DD40F6"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(299,234)",
    d: "m0 0 1 2-5 14-3 1 3-10 3-6z",
    fill: "#610488"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(736,172)",
    d: "m0 0h9v2l7 1 1 2-7-1-10-2z",
    fill: "#81079B"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(389,781)",
    d: "m0 0 9 2 2 3-1 4-2-4-5-2h-9l2-2z",
    fill: "#6A079E"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(337,172)",
    d: "m0 0h9l-2 2-10 3-2-1 3-3z",
    fill: "#9C14B8"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(343,786)",
    d: "m0 0m-1 1m-1 1v3l-7 8-2 2 1-4 3-6z",
    fill: "#9E0FC4"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(329,838)",
    d: "m0 0 2 3 2 8v6l-2-1-2-9z",
    fill: "#EEA5FA"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(270,735)",
    d: "m0 0 3 1 3 12-1 3-5-13z",
    fill: "#7F0698"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(812,310)",
    d: "m0 0 3 1 2 8v5l-2-2-3-9z",
    fill: "#790CB2"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(437,817)",
    d: "m0 0h2l1 5v8l-2-2-1-3z",
    fill: "#F4C5FB"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(666,804)",
    d: "m0 0h6l-1 5h-5l-1-4z",
    fill: "#6A079E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.87a6a929d71939ef20987e0502de2288.svg";
export { ForwardRef as ReactComponent };